(function (window, $j) {
    var emailNextLink = $j("#signupEmailNext"),
        emailSignupForm = $j("#emailForm"),
        emailInputElement = $j("#emailInput");
    //Email validation
    var validateEmail = function(email) {
        var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailReg.test(email);
    };
    //Display error message
    var showError = function() {
        emailSignupForm.find(".input-group").addClass("has-error");
        emailSignupForm.find(".error-text").addClass("has-error");
        emailSignupForm.find(".error-text span").removeClass("hidden");
        emailInputElement.focus();
    };
    var signUpOnSsl = function(e) {
        e.preventDefault();
        var emailAddress = emailInputElement.val();
        if (emailAddress != null && emailAddress.trim().length > 0) {
            if (!validateEmail(emailAddress)) {
                showError();
            } else {
                window.location.href = $j(this).attr("href").replace("{0}", emailAddress);
            }
        } else {
            showError();
        }
    };
    $j(document).ready(function () {
       emailNextLink.click(signUpOnSsl);
    });
})(window, $j);